// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bairun-bianlidian-spugroup .search-spu[data-v-031734e5] .el-select__tags .el-tag{\n  display: none;\n}\n.bairun-bianlidian-spugroup .search-spu[data-v-031734e5] .el-select__tags .el-tag:first-child{\n  display: block;\n}\n.bairun-bianlidian-spugroup .dialog-form[data-v-031734e5] .el-input {\n  width: auto;\n}\n", ""]);
// Exports
module.exports = exports;
